import React from 'react';
import { ReactComponent as ChatbotWindowCloseIcon } from "../../../../assets/ChatbotReportsSvgs/ChatbotWindowCloseIcon.svg";
// import { ChatHistoryGroupInterface, ChatHistorySessionInterface } from 'interface/ReportsChatbotInterface';
import './style.scss';
import { ChatHistoryGroupInterface, ChatHistorySessionInterface } from '../../../../interface/ReportsChatbotInterface';

interface ChatHistoryListingProps {
    history: ChatHistoryGroupInterface[];
    onSelectSession: (session: ChatHistorySessionInterface) => void;
    onClose: () => void;
}

const formatTime = (isoString: string): string => {
    try {
        return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch {
        return '';
    }
};

const formatGroupDate = (dateString: string): string => {
    try {
        const date = new Date(dateString);
        const today = new Date();

        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();

        const formattedDate = date.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        });

        return isToday ? `Today - ${formattedDate}` : formattedDate;
    } catch {
        return dateString;
    }
};

const ChatHistoryListing: React.FC<ChatHistoryListingProps> = ({ history, onSelectSession, onClose }) => {
    return (
        <div className="chat-history-listing-container">
            {/* <div className="chat-history-listing-header">
                <button className="chat-history-back-btn" type="button" onClick={onClose} aria-label="Back">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <span className="chat-history-listing-title">Recent Insights</span>
                <ChatbotWindowCloseIcon className="chat-history-close-icon" onClick={onClose} />
            </div> */}

            <div className="chat-history-listing-scroll">
                {history.length === 0 ? (
                    <div className="chat-history-empty">No history available</div>
                ) : (
                    history.map((group) => (
                        <div key={group.date} className="chat-history-group">
                            <div className="chat-history-group-date">{formatGroupDate(group.date)}</div>
                            {group.sessions.map((session) => (
                                <div
                                    key={session.session_id}
                                    className="chat-history-session-row"
                                    onClick={() => onSelectSession(session)}
                                >
                                    <span className="chat-history-session-preview">
                                        {session.preview ?? session.messages[0]?.content ?? 'View conversation'}
                                    </span>
                                    <span className="chat-history-session-time">
                                        {formatTime(session.last_updated)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ChatHistoryListing;
